import * as React from "react";
import Layout from "../../components/layout";
import { graphql, Link } from "gatsby";
import { MDXRenderer } from "gatsby-plugin-mdx";

const BlogPost = ({ data }) => {
  return (
    <Layout>
      <div className="relative bg-gradient-to-r from-pink to-purple text-white p-14 ibm-font rounded-md my-10">
        <h2 className="text-3xl sm:text-6xl">{data.mdx.frontmatter.title}</h2>
        <p className="mt-10">Le : {data.mdx.frontmatter.date}</p>
        <Link
          to="/blog"
          activeClassName="active"
          className=" absolute -top-5 right-5 bg-text-main text-primary px-6 py-2 hover:border-2 hover:border-violet-900 hover:bg-white hover:text-text-main rounded-xl dark:hover:border-white dark:hover:white dark:hover:bg-primary"
        >
          Retour
        </Link>
      </div>
      <div className="m-2 sm:m-10 mb-20">
        <MDXRenderer>{data.mdx.body}</MDXRenderer>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query ($id: String) {
    mdx(id: { eq: $id }) {
      frontmatter {
        title
        date(formatString: "D MMMM YYYY", locale: "fr")
        tags
      }
      body
    }
  }
`;

export default BlogPost;
